import { render, staticRenderFns } from "./home-asset-info.vue?vue&type=template&id=5aa960e7&"
import script from "./home-asset-info.vue?vue&type=script&lang=ts&"
export * from "./home-asset-info.vue?vue&type=script&lang=ts&"
import style0 from "./home-asset-info.vue?vue&type=style&index=0&id=5aa960e7&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports